import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";
import type { GridConfig, Order, Trade } from "@/types/api";

export interface GridPosition {
  size: number;
  avg_entry: number;
  leg_count: number;
}

export interface VolatilityStatus {
  mode: "normal" | "fast";
  velocity: number;
  trend: "up" | "down" | null;
}

export interface GridDetailData {
  grid: GridConfig;
  orders: Order[];
  trades: Trade[];
  position: GridPosition | null;
  unmatched_openings: Trade[];
  volatility: VolatilityStatus | null;
}

export function useGridDetail(id: string) {
  return useQuery<GridDetailData>({
    queryKey: ["grid-detail", id],
    queryFn: () => apiGet<GridDetailData>(`/grids/${id}`),
    // SSE pushes invalidation on trade/order/activity changes; 30s safety net.
    refetchInterval: 30_000,
    enabled: !!id,
  });
}
